var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"zoom"}},[_c('div',{staticClass:"fixed-return",on:{"click":function($event){_vm.$router.go(-1)}}},[_vm._v("返回")])])}
var staticRenderFns = []

export { render, staticRenderFns }